import React from "react";
import { Scissors, Sparkles, MapPin, Phone } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { waLink } from "../lib/constants";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle } from "../components/site/Primitives";
import LeadForm from "../components/LeadForm";
import SEO from "../components/SEO";

const WA_OPTIONS = [
  { key: "barbearia", label: "Agendar na Barbearia", icon: Scissors, desc: "Barbearia das Estrelas" },
  { key: "arapiraca", label: "Avaliação em Arapiraca", icon: Sparkles, desc: "Prótese capilar" },
  { key: "garanhuns", label: "Avaliação em Garanhuns", icon: Sparkles, desc: "Prime Capilar Clinic" },
  { key: "maceio", label: "Avaliação em Maceió", icon: Sparkles, desc: "Parceria Arena Barbearia" },
];

export default function Contato() {
  const { site } = useSite();

  return (
    <div>
      <SEO title="Contato | Barbearia das Estrelas e Prime Capilar Clinic" description="Fale com a Barbearia das Estrelas e a Prime Capilar Clinic pelo WhatsApp. Atendimento em Arapiraca, Garanhuns e Maceió." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Contato</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Fale com a gente</SectionTitle></Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <Reveal>
          <div>
            <h3 className="font-heading font-600 uppercase text-white text-xl">WhatsApp direto</h3>
            <p className="text-zinc-400 text-sm mt-2 mb-6">Escolha o atendimento e fale agora com nosso time.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {WA_OPTIONS.map((o) => (
                <a key={o.key} href={waLink(site, o.key)} target="_blank" rel="noreferrer" data-testid={`contato-wa-${o.key}`}
                  className="group flex items-center gap-3 border border-white/12 hover:border-gold rounded-sm p-4 transition-colors">
                  <div className="w-10 h-10 rounded-sm bg-gold/10 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors">
                    <o.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="font-heading font-600 text-white text-sm">{o.label}</p>
                    <p className="text-xs text-zinc-500">{o.desc}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="mt-8 space-y-2.5 text-sm text-zinc-300">
              <p className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-gold" /> {site?.whatsapp ? `+${site.whatsapp}` : ""}</p>
              <p className="flex items-center gap-2.5"><MapPin className="w-4 h-4 text-gold" /> Arapiraca, AL · Garanhuns, PE · Maceió, AL</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="border border-white/12 rounded-sm bg-[#0b0b0b] p-6 lg:p-8">
            <h3 className="font-heading font-600 uppercase text-white text-xl mb-5">Formulário de avaliação</h3>
            <LeadForm paginaOrigem="Contato" />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
